import { baseReducer as BaseReducer } from '../../store/core/base-reducer';
import * as ConnectActions from '../../store/shipstation-connect/ss-connect.actions';
import * as Actions from './one-time-scale.actions';

const initialState = {
  oneTimeReadScaleRequestId: undefined,
};

const actionHandlerMap = {
  [Actions.ONE_TIME_READ_SCALE_REQUEST]: (state, { requestId }) => {
    return {
      ...state,
      weight: undefined,
      oneTimeReadScaleRequestId: requestId,
    };
  },
  [ConnectActions.READ_CONVERTED_SCALE_RESPONSE]: (state, { requestId, weight, weightUnit }) => {
    const { oneTimeReadScaleRequestId } = state;
    if (oneTimeReadScaleRequestId === requestId) {
      const updateWeight = { weight: { weight, weightUnit } };
      return {
        ...state,
        weight: updateWeight,
        oneTimeReadScaleRequestId: undefined,
      };
    }
    return state;
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './one-time-scale.reducer.metadata';
